module.exports = __webpack_public_path__ + "assets/img/news (10).306b7f04.png";